import Svg, { Path } from "react-native-svg";
import type { SvgProps } from "react-native-svg";
import { memo } from "react";
const SvgChevronLeft = (props: SvgProps) => <Svg xmlns="http://www.w3.org/2000/svg" width={28} height={48} fill="none" viewBox="0 0 28 48" {...props}><Path fill="currentColor" fillRule="evenodd" d="M23.692.5 0 24l23.692 23.5L28 43.227 8.615 24 28 4.773 23.692.5Z" clipRule="evenodd" /></Svg>;
const Memo = memo(SvgChevronLeft);
export default Memo;